<template>
  <div class="springClass">
    <headers ref="header" style="position: fixed;width: 100%;z-index:99" :isChange="true"/>
    <div class="springNav">
    </div>
    <div class="theleft" @click="nav()">
    </div>
    <!-- tab选项 -->
    <div class="switchTab">
      <ul><li v-for="(ele,index) in switchTab" :key="index" @click="switchTabs(ele.type)" :class="n == ele.type ? 'active':''"><a :href="ele.theurlId">{{ele.tit}}</a></li></ul>
    </div>
    <!-- 适用学员 -->
    <div id="dd1" class="student">
      <h1>适用学员</h1>
      <div class="studentCard">
        <div class="studentCardCon" v-for="(item,indexs) in studentCard" :key="indexs">
          <p class="img"><img :src="item.icons"></p>
          <p><h2>{{item.name}}</h2></p>
          <p class="cardmarginP">{{item.studentStatus1}}</p>
          <p>{{item.studentStatus2}}</p>
        </div>
      </div>
    </div>
    <!-- 方案第一点 -->
    <div class="courseBrief" id="dd2">
      <h1 class="titles">解决方案</h1>
      <div class="courseBriefCon">
        <p class="personality">个性化教学，针对性地根据个人特点进行辅导</p>
        <p>课前测评，精确诊断，科学规划。我们为不同基础学员提供不同难度等级的入学测评，以保证针对性教学。</p>
        <div class="planImg">
          <img src="@/assets/onOne/planImg1.png">
          <img src="@/assets/onOne/planImg2.png">
        </div>
      </div>
    </div>
    <!-- 方案第二点 -->
    <div class="evaluat" id="">
      <h1 class="titles">根据课前测评，针对性定制课程</h1>
      <p>科学授课，因材施教，讲练结合</p>
      <div class="evaluatHeader">
        <img class="videxn" src="@/assets/onOne/evaluatImg1.png" alt="">
        <img class="videoImg" src="@/assets/onOne/evaluatImg2.jpg" alt="">
      </div>
      <p id="thespeck">讲练同步结合</p>
      <p class="evaluatHeader_arrange">安排符合学员特点的课后作业，讲练同步结合</p>
      <div class="evaluatHeader">
        <img class="evaluatHeader_im" src="@/assets/onOne/evaluatCon.png" alt="">
      </div>
    </div>
    <!-- 方案第三点 -->
    <div class="teacherAnswer">
      <p id="themainspeck">主讲老师亲自答疑</p>
      <p class="answerTit">主讲老师亲自答疑，快速提高学习基础</p>
      <div class="answerImgs">
        <img src="@/assets/onOne/teacherNav.png" alt="">
      </div>
    </div>
    <!-- 课程优势 -->
    <div class="courseAdvantage" id="dd3">
      <div class="newCard">
        <div class="new_item">
        <p class="tit">课程优势</p>
        <p class="ol">01. </p>
        <div class="swiper">
          <el-carousel  arrow="never" indicator-position="none" :autoplay="false">
                <el-carousel-item v-for="(item,index) in 4" :key="index" style="height: 487px;">
                  <!-- {{item.length}}s -->
                  <div class="content">
                      <!-- v-if="item.teacherTeams[i]" -->
                    <div class="left">
                      <p>顶级名师授课</p>
                      <!-- {{teacherTeams}} -->
                      <p>{{teacherTeams[i].nick}}<span>{{teacherTeams[i].position}}</span></p>
                      <p>{{teacherTeams[i].profile}}</p>
                      <div class="shit_fuck">
                        <swiper :options="teacherImg2" :not-next-tick="notNextTick" ref="wocaorile" style="width: 530px;" @slideChange="slideChange" class="swiper-no-swiping">
                          <!-- slides -->
                          <swiper-slide class="swiperText" v-for="(item,index) in imgs" :key="index">
                            <img :src="item.url" alt="" @click="act(index)">
                          </swiper-slide>
                          <!-- Optional controls -->
                          <div class="swiper-button-prev" slot="button-prev" @click="prev()"></div>
                          <div class="swiper-button-next" slot="button-next" @click="next()"></div>
                        </swiper>
                      </div>
                    </div>
                    <div class="right"><img :src="imgs[i].img" alt=""></div>
                  </div>
                </el-carousel-item>
              </el-carousel>
        </div>
        </div>
      </div>
      <div class="advantageCard advantageTexts" id="dd4">
        <p class="advantCardText advantageCardTits">02.</p><p class="cardTitles">超个性化的定制课程</p>
        <div class="cao">
          <div class="cao_left">
            <p><img src="../../assets/onOne/cao/icon1.png" alt=""></p><p>根据学生课前测评结果、课堂反馈、作业进度、ESR分析等，综合调整课程框架，为学生量身定制。在系统化覆盖GMAT的全部考点的同时，有的放矢。此外，因为老师们对GMAT题库的熟悉度处于行业顶尖水平，老师们会精心挑选最具有代表性的真题，将真题与知识点、做题方法紧密结合，通过每次课程的作业任务和讲解，帮助VIP学生切实巩固和消化知识点。</p>
            <p><img src="../../assets/onOne/cao/icon1.png" alt=""></p>
          </div>
          <div class="cao_right"><img src="../../assets/onOne/cao/img3.png" alt=""></div>
        </div>
      </div>
      <div class="advantageCard advantageTexts">
        <p class="advantCardText advantageCardTits">03.</p>
        <p class="cardTitles">每日不间断的保姆式一对一服务</p>
        <div class="ri">
          <div class="ri_box">
            <div class="ri_top">
              <div class="ri_one"><p><span>1</span></p><p>主讲老师保姆式服务</p></div>
              <div><p>主讲老师360天</p><p>在线一对一答疑</p><p class="ri_ri"><span><span></span></span></p></div>
              <div><p class="ri_ri"><span><span></span></span></p><p>主讲老师亲自负责</p><p>检查作业与作业批改</p></div>
              <div><p>主讲老师亲自负责ESR分析</p><p class="ri_ri"><span><span></span></span></p></div>
              <div><p class="ri_ri"><span><span></span></span></p><p>主讲老师亲自</p><p>负责备考规划方案设计</p></div>
            </div>
            <div class="ri_bottom">
              <div><p>一对一课程配备金牌督导老师</p><p>全程陪伴同学们的每日学习，专治拖延症</p><p class="ri_ri"><span><span></span></span></p></div>
              <div><p class="ri_ri"><span><span></span></span></p><p>提供心理疏导和</p><p>曾经的备考经验</p></div>
              <div><p>检查主讲老师布置的</p><p>任务的每日完成情况</p><p class="ri_ri"><span><span></span></span></p></div>
              <div><p class="ri_ri"><span><span></span></span></p><p>检查单词背诵情况</p></div>
              <div><p>制定专属一对一备考规划书</p><p class="ri_ri"><span><span></span></span></p></div>
              <div class="ri_two"><p><span>2</span></p><p>督导老师保姆式服务</p></div>
            </div>
          </div>
        </div>
      </div>
      <div class="advantageCard advantageTexts">
        <p class="advantCardText advantageCardTits">04.</p>
        <p class="cardTitles">享受比全能班更多的独家真题资料</p>
        <p class="fuck_tit">“独家结课礼包+全网最强机经“为你甄选满足实战需求的大量GMAT真题。</p>
        <div class="big_gun">
          <div class="big_gun_left">
            <div><span></span><span>别家机构有的资料我们都有</span></div>
            <div>常规的资料：OG/PREP/GWD/OG分册/Advanced 300题，我们统统都有。</div>
            <div>
              <div><img src="../../assets/onOne/cao/icon9.png" alt=""></div>
              <div>“拥有市面最全真题题库”的老师们会为大家提供市面上没有的独家最新真题，帮助学员真正地模拟考试真实难度（杀G工厂的独家真题资料素来好评无数，甚至很多没时间报班的学员也曾经慕名前来，想要单独购买真题礼包）。</div>
            </div>
          </div>
          <div class="big_gun_right">
            <div><span></span><span>别家机构有的资料我们都有</span></div>
            <div>经常有同学抱怨：怎么在考试时，觉得题目的难度跟OG、PREP、GWD这些题目不太一样呢？Emmm……因为就是不一样啊！</div>
            <div>
              <div><img src="../../assets/onOne/cao/icon9.png" alt=""></div>
              <div>所以不管是小白，还是老司机，你的需求都被安排得妥妥的~并且，一对一学生可享受老师的超大历年机经真题题库与机经，可以针对任何个人欠缺的知识盲点进行大量高质量真题练习！</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  安排与常见问题 -->
    <div class="courseArrange">
      <!-- 课程安排 -->
      <!-- 常见问题 -->
      <div class="commonProblem" id="dd5">
        <h1>常见问题</h1>
          <div class="matterBox2">
              <div class="rightBox2">
                  <div><span><b>1、如何购买课程?</b>本网站所有课程授课均在cctalk第三方平台完成，课程质量、后续服务以及资金安全，均由第三方监督保障。如欲咨询课程、领取优惠券或报名课程<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;等，请联系小助手（微信号）jjgmat780/jjgmat800。</p></span></div>
                  <div><span><b>2、上课所需设备?</b>电脑端、手机端、Pad端任意一端均可兼容。</span></div>
                  <div><span><b>3、一对一上课形式?</b>主讲老师连麦+共享白板屏幕+语音实时互动。课前布置作业，课后定期检查，下次课程及时讲解。</span></div>
                  <div><span><b>4、老师在哪里答疑?</b>所有科目的答疑由主讲老师亲自负责一对一答疑。</span></div>
                  <div><span><b>5、其它问题?</b>扫码咨询小助手，我们尽全力解答您的问题。</span></div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import home from "@/api/home.js";
import api from "@/api/sprintClass.js";
import headers from "@/components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      i: 0,
      imgs: [
        {
          url: require("../../assets/teachers/img5.png"),
          img: require("../../assets/teachers/img7.png"),
        },
        {
          url: require("../../assets/teachers/img3.png"),
          img: require("../../assets/teachers/img9.png"),
        },
        {
          url: require("../../assets/teachers/img1.png"),
          img: require("../../assets/teachers/img12.png"),
        },
        {
          url: require("../../assets/teachers/img4.png"),
          img: require("../../assets/teachers/img8.png"),
        },
        {
          url: require("../../assets/teachers/img2.png"),
          img: require("../../assets/teachers/img11.png"),
        },

        {
          url: require("../../assets/teachers/img6.png"),
          img: require("../../assets/teachers/img13.png"),
        },
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕黄金糕黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
      value: "",
      navCodes: require("@/assets/login/navCode.png"),
      herderTits: {
        color: "#666666",
      },
      headerBack: {
        background: "#ffffff",
      },
      headerIcon: require("@/assets/home/headerNav.png"),
      n: 1,
      switchTab: [
        { tit: "适用学员", type: 1, theurlId: "#dd1" },
        { tit: "课程简介", type: 2, theurlId: "#dd2" },
        { tit: "课程优势", type: 3, theurlId: "#dd3" },
        { tit: "出分效果", type: 4, theurlId: "#dd4" },
        // { tit: "课程安排", type: 5 },
        { tit: "常见问题", type: 5, theurlId: "#dd5" },
      ],
      teacherImg2: {
        loop: true,
        autoplay: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 5,
      },
      //适用学员
      studentCard: [
        {
          icons: require("@/assets/onOne/student.png"),
          name: "首战小白快速出分",
          studentStatus1: "基础薄弱待解散",
          studentStatus2: "名师领衔不迷路",
        },
        {
          icons: require("@/assets/onOne/data.png"),
          name: "N战选手短期提分",
          studentStatus1: "深陷瓶颈难自愈",
          studentStatus2: "醍醐灌顶终突破",
        },
        {
          icons: require("@/assets/onOne/chongci.png"),
          name: "冲击750+",
          studentStatus1: "高分突破申名校",
          studentStatus2: "750在手offer我有",
        },
        {
          icons: require("@/assets/onOne/time.png"),
          name: "上课时间不固定",
          studentStatus1: "零碎时间全利用",
          studentStatus2: "一点一滴沙成塔",
        },
        {
          icons: require("@/assets/onOne/search.png"),
          name: "查漏补缺",
          studentStatus1: "考前密集抓训练",
          studentStatus2: "短板漏洞全补足",
        },
      ],
      teacherTeams: [{nick:null}],
      arrangeN: 0,
      //课程安排 Tab
      arrangeTab: [],
      //课程安排 table
      tableData: [],
      matters: 0,
      //常见问题tab
      matterTab: [],
      probleList: [],
      notNextTick: true,
      //swiper
      teacherAnswer: {
        autoplay: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 1,
      },
      teacherAnswer1: {
        autoplay: false,
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        slidesPerView: 3,
      },
      //学员案例
      studentSase: [],
      //出分效果
      givePoints: [],
      navInfo: {},
    };
  },
  mounted() {
    this.getTeacherList();
    window.addEventListener("scroll", this.handleScrollx);
    // this.problems();
    this.studentList();
    this.effectClass();
    this.arrangeList();
    this.getNav();
  },
  beforeDestroy() {
    // console.log('销毁');
    window.removeEventListener("scroll", this.handleScrollx);
  },
  methods: {
    xin() {
        $(function(){
          $('#right23').click(function(){
            //根据a标签的href转换为id选择器，获取id元素所处的位置，并高度减50px（这里根据需要自由设置）
            $('html,body').animate({scrollTop: ($($(this).attr('href')).offset().top -50 )},1000);
          });
        });
      // $(document).ready(function () {
      //   $("a.topLink").click(function () {
      //     $("html, body").animate(
      //       {
      //         scrollTop: $($(this).attr("href")).offset().top + "px",
      //       },
      //       {
      //         duration: 500,
      //         easing: "swing",
      //       }
      //     );
      //     return false;
      //   });
      // });
    },
    getTeacherList() {
      let params = {
        type: "home",
      };
      let query = this.$qs.stringify(params);
      home
        .getTeacher(query)
        .then((res) => {
          this.teacherTeams = res.data.data;
          console.log(this.teacherTeams);
        })
        .catch((err) => {
          this.$message.error("错误");
        });
    },
    prev() {
      if (this.$refs.wocaorile[0].swiper.realIndex > 0) {
        this.i = this.$refs.wocaorile[0].swiper.realIndex - 1;
        console.log(this.i);
      } else {
        this.i = 5;
      }
    },
    next() {
      if (this.$refs.wocaorile[0].swiper.realIndex < 5) {
        this.i = this.$refs.wocaorile[0].swiper.realIndex + 1;
        console.log(this.i);
      } else {
        this.i = 0;
      }
    },
    handleScrollx() {
      let header = this.$refs.header;
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop == 0) {
        header.headerBack.background = "";
        header.herderTits.color = "hsla(0,0%,100%,.8)";
        header.headerIcon = require("@/assets/bottom/bottomIcon.png");
        header.loginButton = {
          backgroundColor: "white",
          color: " rgba(0,0,0,.8)",
        };
        header.isTop = true;

        header.phoneButton = {
          background: "hsla(0,0%,100%,.08)",
          border: "1px solid hsla(0,0%,100%,.8)",
        };
        // this.navCodes = require('@/assets/login/whiteCode.png');
      } else {
        header.isTop = false;
        header.headerBack.background = "#ffffff";
        header.herderTits.color = "#666666";
        header.headerIcon = require("@/assets/home/headerNav.png");
        header.loginButton = {
          background: "#618aff",
          color: "#fff",
        };
        header.phoneButton = {
          color: "#618aff",
          border: "1px solid #618aff",
        };
        // this.navCodes = require('@/assets/login/navCode.png');
      }
      if (scrollTop > 723) {
        this.rightDiv = true;
      } else {
        this.rightDiv = false;
      }
    },
    //导航内容
    getNav() {
      let params = {
        type: "oneOnOne",
      };
      let query = this.$qs.stringify(params);
      api.getNavInfo(query).then((res) => {
        if (res.data.code == 0) {
          this.navInfo = res.data.data;
          console.log(this.navInfo, "导航");
        }
      });
    },
    switchTabs(type) {
      // console.log(ele)
      this.n = type;
    },
    switchArrange(type, data) {
      this.arrangeN = type;
      this.tableData = data;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.channel == "录播") {
        return "warning-row ";
      } else {
        return "success-row";
      }
      return "";
    },
    //常见问题tab切换
    switchMatter(type, list) {
      this.matters = type;
      this.probleList = list;
    },
    //常见问题
    // problems() {
    //   let paramas = {
    //     type: "oneOnOne",
    //   };
    //   let query = this.$qs.stringify(paramas);
    //   api
    //     .commonProblem(query)
    //     .then((res) => {
    //       this.matterTab = res.data.data;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //学员案例
    studentList() {
      let paramas = {
        type: "oneOnOne",
      };
      let query = this.$qs.stringify(paramas);
      api
        .studentCase(query)
        .then((res) => {
          this.studentSase = res.data.data;
        })
        .catch((err) => {
          this.$message.error("学员案例获取失败");
        });
    },
    //出分效果
    effectClass() {
      let paramas = {
        type: "oneOnOne",
      };
      let query = this.$qs.stringify(paramas);
      api
        .studyEffect(query)
        .then((res) => {
          this.givePoints = res.data.data;
        })
        .catch((err) => {
          this.$message.error("出分效果获取失败");
        });
    },
    //课程安排
    arrangeList() {
      let paramas = {
        type: "oneOnOne",
      };
      let query = this.$qs.stringify(paramas);
      api
        .arrangeClass(query)
        .then((res) => {
          this.arrangeTab = res.data.data;
        })
        .catch((err) => {
          this.$message.error("课程安排获取失败");
        });
    },
    slideChange() {},
    nav() {
      this.$router.push("/excellentcourse");
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/onOne.css");
</style>



// WEBPACK FOOTER //
// src/view/excellentCourse/onOne.vue